/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Scatter, defaults } from "react-chartjs-2";
import _ from "lodash";
import CustomTooltip from "app/common/chart/CustomTooltipComponent";
import computeScenarioTotalsForCard from "lib/utils/scenarios";
import { useMediaQuery } from "@material-ui/core";
import { useSelector } from "react-redux";
import { SellOut } from "resources/constants";
import ScenarioTotalsCardComponent from "./ScenarioTotalsCardComponent";

const ScenarioMapChartComponent = ({
  metadata,
  scenariosList,
  disabledScenariosList,
  scenarioMapSelectedScenario,
  scenarioMapReferenceScenario,
  updateSelectedScenario,
}) => {
  const refs = useRef();
  const [tooltipProps, setTooltipProps] = useState({});
  const [chartData, setChartData] = useState({});
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const sellOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? SellOut
    : "Sell Out";

  const setPositionAndData = (payload) => {
    setTooltipProps({
      top: payload.top,
      left: payload.left,
      position: "fixed",
      tooltipModel: payload.tooltipModel,
      showTooltip: true,
      width: "250px",
    });
  };

  const hide = () => {
    setTooltipProps({
      ...tooltipProps,
      showTooltip: false,
    });
  };

  const defaultScenariosColorArray = Array(
    scenariosList.defaultScenarios.length
  ).fill("#60aa8e");

  const disabledScenariosColorArray = Array(disabledScenariosList.length).fill(
    "#e2e2e2"
  );

  defaults.global.defaultFontFamily = "Lato";

  useEffect(() => {
    setChartData({
      labels: ["Scatter"],
      datasets: [
        {
          label: "Selected",
          backgroundColor: "#e3ca40",
          pointBorderColor: "#e3ca40",
          pointBackgroundColor: "#e3ca40",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 1,
          pointRadius: 5,
          pointHitRadius: 5,
          data: [
            !_.isEmpty(scenarioMapSelectedScenario)
              ? {
                  ...computeScenarioTotalsForCard(
                    scenarioMapSelectedScenario,
                    scenarioMapReferenceScenario
                  ),
                  price: {
                    absolute:
                      scenarioMapSelectedScenario.sales /
                      scenarioMapSelectedScenario.units,
                    percentage:
                      scenarioMapReferenceScenario.units !== 0
                        ? (100 *
                            (scenarioMapSelectedScenario.sales /
                              scenarioMapSelectedScenario.units -
                              scenarioMapReferenceScenario.sales /
                                scenarioMapReferenceScenario.units)) /
                          (scenarioMapReferenceScenario.sales /
                            scenarioMapReferenceScenario.units)
                        : 0,
                  },
                  // We need to overwrite the investment KPI retrieved from the previous function since it is already compared against reference when computed (as it uses the underlying estimations) and the previous function would substract again the reference investment leading to an incorrect result
                  title:
                    scenarioMapSelectedScenario.scenario.scenario_type_id ===
                      3 ||
                    scenarioMapSelectedScenario.scenario.scenario_type_id === 1
                      ? scenarioMapSelectedScenario.scenario.name
                      : `Scenario ${scenarioMapSelectedScenario.scenario.id}`,
                  subtitle: scenarioMapSelectedScenario.scenario.owner_label,

                  borderStyle: { borderColor: "#e3ca40" },
                  x: scenarioMapSelectedScenario.units,
                  y:
                    metadata.all.margin[0].visibility_type === 2
                      ? scenarioMapSelectedScenario.margin
                      : scenarioMapSelectedScenario.sales,
                }
              : null,
          ],
        },
        {
          label: "Map Reference",
          backgroundColor: "#4e4e4e",
          pointBorderColor: "#4e4e4e",
          pointBackgroundColor: "#4e4e4e",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 1,
          pointRadius: 3,
          pointHitRadius: 3,
          data: _.map(scenariosList.referenceScenarios, (scenarioTotal) =>
            scenarioTotal.id !== scenarioMapSelectedScenario.id
              ? {
                  ...computeScenarioTotalsForCard(
                    scenarioTotal,
                    scenarioMapReferenceScenario
                  ),
                  price: {
                    absolute: scenarioTotal.sales / scenarioTotal.units,
                    percentage:
                      scenarioMapReferenceScenario.units !== 0
                        ? (100 *
                            (scenarioTotal.sales / scenarioTotal.units -
                              scenarioMapReferenceScenario.sales /
                                scenarioMapReferenceScenario.units)) /
                          (scenarioMapReferenceScenario.sales /
                            scenarioMapReferenceScenario.units)
                        : 0,
                  },
                  title:
                    scenarioTotal.scenario.scenario_type_id === 3 ||
                    scenarioTotal.scenario.scenario_type_id === 1
                      ? scenarioTotal.scenario.name
                      : `Scenario ${scenarioTotal.scenario.id}`,
                  subtitle: scenarioTotal.scenario.owner_label,
                  borderStyle: { borderColor: "#4e4e4e" },
                  x: scenarioTotal.units,
                  y:
                    metadata.all.margin[0].visibility_type === 2
                      ? scenarioTotal.margin
                      : scenarioTotal.sales,
                }
              : null
          ),
        },
        {
          label: "Athena",
          backgroundColor: "#60aa8e",
          pointBorderColor: defaultScenariosColorArray,
          pointBackgroundColor: defaultScenariosColorArray,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 1,
          pointRadius: 3,
          pointHitRadius: 3,
          data: _.map(scenariosList.defaultScenarios, (scenarioTotal) =>
            scenarioTotal.id !== scenarioMapSelectedScenario.id
              ? {
                  ...computeScenarioTotalsForCard(
                    scenarioTotal,
                    scenarioMapReferenceScenario
                  ),
                  price: {
                    absolute: scenarioTotal.sales / scenarioTotal.units,
                    percentage:
                      scenarioMapReferenceScenario.units !== 0
                        ? (100 *
                            (scenarioTotal.sales / scenarioTotal.units -
                              scenarioMapReferenceScenario.sales /
                                scenarioMapReferenceScenario.units)) /
                          (scenarioMapReferenceScenario.sales /
                            scenarioMapReferenceScenario.units)
                        : 0,
                  },
                  title:
                    scenarioTotal.scenario.scenario_type_id === 3 ||
                    scenarioTotal.scenario.scenario_type_id === 1
                      ? scenarioTotal.scenario.name
                      : `Scenario ${scenarioTotal.scenario.id}`,
                  subtitle: scenarioTotal.scenario.owner_label,
                  borderStyle: { borderColor: "#60aa8e" },
                  x: scenarioTotal.units,
                  y:
                    metadata.all.margin[0].visibility_type === 2
                      ? scenarioTotal.margin
                      : scenarioTotal.sales,
                }
              : null
          ),
        },
        {
          label: "Restricted",
          backgroundColor: "#e2e2e2",
          pointBorderColor: disabledScenariosColorArray,
          pointBackgroundColor: disabledScenariosColorArray,
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBorderWidth: 1,
          pointRadius: 3,
          pointHitRadius: 3,
          data: _.map(disabledScenariosList, (scenarioTotal) =>
            scenarioTotal.id !== scenarioMapSelectedScenario.id
              ? {
                  ...computeScenarioTotalsForCard(
                    scenarioTotal,
                    scenarioMapReferenceScenario
                  ),
                  price: {
                    absolute: scenarioTotal.sales / scenarioTotal.units,
                    percentage:
                      scenarioMapReferenceScenario.units !== 0
                        ? (100 *
                            (scenarioTotal.sales / scenarioTotal.units -
                              scenarioMapReferenceScenario.sales /
                                scenarioMapReferenceScenario.units)) /
                          (scenarioMapReferenceScenario.sales /
                            scenarioMapReferenceScenario.units)
                        : 0,
                  },
                  title:
                    scenarioTotal.scenario.scenario_type_id === 3 ||
                    scenarioTotal.scenario.scenario_type_id === 1
                      ? scenarioTotal.scenario.name
                      : `Scenario ${scenarioTotal.scenario.id}`,
                  subtitle: scenarioTotal.scenario.owner_label,
                  borderStyle: { borderColor: "#e2e2e2" },
                  x: scenarioTotal.units,
                  y:
                    metadata.all.margin[0].visibility_type === 2
                      ? scenarioTotal.margin
                      : scenarioTotal.sales,
                }
              : null
          ),
        },
      ],
    });
  }, [scenariosList]);

  const chartOptions = {
    maintainAspectRatio: false,
    animation: false,
    onHover: useCallback(
      (event, chartElement) => {
        const newEvent = event;
        newEvent.target.style.cursor = chartElement[0] ? "pointer" : "default";
      },
      [disabledScenariosList]
    ),
    onClick: useCallback(
      (evt) => {
        const chart = refs.current.chartInstance;
        const element = chart.getElementAtEvent(evt);

        if (element.length > 0) {
          const idx = element[0]._index;
          const datasetIdx = element[0]._datasetIndex;
          let selectedScenario;

          if (datasetIdx !== 0) {
            switch (datasetIdx) {
              case 1:
                selectedScenario = scenariosList.referenceScenarios[idx];
                break;
              case 2:
                selectedScenario = scenariosList.defaultScenarios[idx];
                break;
              case 3:
                selectedScenario = disabledScenariosList[idx];
                break;
              default:
                break;
            }
            updateSelectedScenario(selectedScenario);
          }
        }
      },
      [scenariosList]
    ),
    tooltips: {
      enabled: false,
      intersect: isSmallScreen,
      mode: "nearest",
      custom: useCallback((tooltipModel) => {
        if (tooltipModel.opacity === 0) {
          hide();
          return;
        }

        const chart = refs.current.chartInstance;
        const { canvas } = chart.ctx;

        if (canvas) {
          const position = canvas.getBoundingClientRect();

          // set position of tooltip
          const left =
            tooltipModel.caretX <= chart.width / 2
              ? position.left + tooltipModel.caretX + 40
              : position.left + tooltipModel.caretX - 280;
          const top =
            tooltipModel.caretY <= chart.height / 2
              ? position.top + tooltipModel.caretY - 20
              : position.top + tooltipModel.caretY - 60;

          setPositionAndData({ top, left, tooltipModel });
        }
      }, []),
    },
    layout: {
      padding: {
        left: 10,
        right: 20,
        top: 20,
        bottom: 20,
      },
    },
    scales: {
      xAxes: [
        {
          id: "units",
          scaleLabel: {
            labelString: sellOutLabelByTenant,
            display: true,
          },
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            display: false,
          },
        },
      ],
      yAxes: [
        {
          scaleLabel: {
            labelString:
              metadata.all.margin[0].visibility_type === 2 ? `Margin` : `Sales`,
            display: true,
          },
          gridLines: {
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            padding: 10,
            display: false,
          },
        },
      ],
    },
  };

  return (
    chartData && (
      <>
        <Scatter data={chartData} ref={refs} options={chartOptions} />
        {tooltipProps.showTooltip ? (
          <CustomTooltip
            tooltipProps={tooltipProps}
            metadata={metadata}
            body={
              <ScenarioTotalsCardComponent
                isReference={
                  refs.current.chartInstance.data.datasets[
                    tooltipProps.tooltipModel.dataPoints[0].datasetIndex
                  ].data[tooltipProps.tooltipModel.dataPoints[0].index].scenario
                    .scenario_type_id === 1
                }
                cardData={
                  refs.current.chartInstance.data.datasets[
                    tooltipProps.tooltipModel.dataPoints[0].datasetIndex
                  ].data[tooltipProps.tooltipModel.dataPoints[0].index]
                }
                visibleKeys={[
                  "price",
                  "units",
                  "sales",
                  "margin",
                  "roi",
                  "investment_in",
                ]}
                showIcons={false}
                showLabels
                orderWithVisibleKeys
                metadata={metadata}
              />
            }
            tooltipData={
              refs.current.chartInstance.data.datasets[
                tooltipProps.tooltipModel.dataPoints[0].datasetIndex
              ].data[tooltipProps.tooltipModel.dataPoints[0].index]
            }
          />
        ) : null}
      </>
    )
  );
};

export default ScenarioMapChartComponent;
